import gsap from 'gsap';
import Sniffer from 'sniffer';

import { app, webgl } from '@/utils/store';

export default class Transitions {
  constructor() {
    this.type = {
      menu: document.querySelector('[data-transition="menu"]'),
      next: document.querySelector('[data-transition="next"]'),
      contact: document.querySelector('[data-transition="contact"]'),
    };

    this.dom = {
      main: document.querySelector('.a-main'),
      slider: document.getElementById('a-slider'),
    };

    this.e = {
      el: undefined,
      done: undefined,
    };

    this.l = {
      el: undefined,
      done: undefined,
    };

    this.trigger = 'default';
  }

  init = () => {
    if (this.type.menu) {
      this.type.menu.addEventListener('click', () => {
        this.trigger = 'menu';
      });
    }
    if (this.type.contact) {
      this.type.contact.addEventListener('click', () => {
        this.trigger = 'contact';
      });
    }
    if (this.type.next) {
      this.type.next.addEventListener('click', () => {
        this.trigger = 'next';
      });
    }
  }

  leave = (el, done) => {
    this.l.el = el;
    this.l.done = done;

    app.loading = true;

    // default
    if (this.trigger === 'default') {
      done();
    }

    // menu
    if (this.trigger === 'menu') {
      done();
    }

    // contact
    if (this.trigger === 'contact') {
      this.dom.slider.style.visibility = 'hidden';
    }

    // contact / next
    if (this.trigger === 'contact' || this.trigger === 'next') {
      const y = this.l.el.scrollHeight - window.innerHeight - Math.abs(app.scroll.data.current);

      document.body.classList.add('is-loading');

      gsap.to(this.l.el, {
        duration: 2,
        clearProps: 'all',
        ease: 'expo.inOut',
        y: -(window.innerHeight + Math.abs(app.scroll.data.current) + y),

        onComplete: () => {
          this.l.done();
          this.e.done();
          document.body.classList.remove('is-loading');
        },
      });
    }

    // contact
    if (this.trigger === 'contact') {
      webgl.app.pause();
      webgl.pause = true;

      gsap.set(this.dom.slider, {
        y: -window.innerHeight,
      });
    }

    // next
    if (this.trigger === 'next') {
      webgl.app.play();
      webgl.pause = false;

      let offset;

      if (Sniffer.isPhone) {
        offset = window.innerHeight * 0.15;
      } else {
        offset = 0;
      }

      gsap.fromTo(webgl.app, {
        shadowOpacity: 0,
        offsetY: -window.innerHeight,
      }, {
        duration: 2,
        offsetY: offset,
        shadowOpacity: 1,
        ease: 'expo.inOut',
      });

      gsap.fromTo(this.dom.slider, {
        y: window.innerHeight,
      }, {
        y: 0,
        duration: 2,
        ease: 'expo.inOut',
      });
    }
  }

  enter = (el, done) => {
    this.e.el = el;
    this.e.done = done;

    this.e.el.style.visibility = 'inherit';

    // default
    if (this.trigger === 'default') {
      if (this.e.el.classList.contains('p-contact')) {
        gsap.set(this.dom.slider, {
          y: -window.innerHeight,
        });
        gsap.set(webgl.app, {
          offsetY: -window.innerHeight,
        });
      }
      done();
    }

    // menu
    if (this.trigger === 'menu') {
      done();
    }

    // contact / next
    if (this.trigger === 'next' || this.trigger === 'contact') {
      gsap.fromTo(this.e.el, {
        y: window.innerHeight,
      }, {
        y: 0,
        duration: 2,
        clearProps: 'all',
        ease: 'expo.inOut',
      });
    }
  }

  afterEnter = (el) => {
    this.e.el = el;

    app.loading = false;
  }
}
